import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ELearningService } from '../../e-learning.service';

@Component({
  selector: 'app-modal-assignment',
  templateUrl: './modal-assignment.component.html',
  styleUrls: ['./modal-assignment.component.scss']
})
export class ModalAssignmentComponent implements OnInit {
  fileList: NzUploadFile[] = []
  assignForm: FormGroup;
  isLoading: boolean;

  successRequest = ({ file, onSuccess, onError }) => {
    const fileType = this.gbFunction.getTypeFile(file);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    } else {
      setTimeout(() => {
        onError('error');
      }, 0);
    }
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAssignmentComponent>,
    private elearningService: ELearningService,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService

  ) {
    this.assignForm = this.fb.group({
      file: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    // // console.log(this.data);
  }

  downloadFile(fileUrl) {
    window.open(fileUrl, "_blank");
  }

  handleChange(e, assignForm) {
    let fileList = [...e.fileList];
    const fileType = this.gbFunction.getTypeFile(e.file);
    // // console.log(e);

    if (fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'docx' && fileType !== 'xlsx' && fileType !== 'csv') {
      fileList.pop();
      alert('การอัปโหลดเอกสารรองรับไฟล์ CSV, XLSX, PDF, DOC, DOCX เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }

    fileList = fileList.slice(-1);

    if (e.file.status === 'removed') {
      assignForm.controls['file'].setErrors({ 'incorrect': true });
    }

    fileList = fileList.map(file => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    assignForm.patchValue({
      file: e
    });
    assignForm.get('file').updateValueAndValidity()

    this.fileList = fileList;
  }

  uploadFile() {
    this.isLoading = true;
    const body = {
      FEEDBACK_DOC: this.fileList[0].originFileObj,
      ASSIGNMENT_ID: this.data.topicId
    }

    this.elearningService.createFeedBackByUser(body).pipe(
      switchMap(() => {
        const body = {
          TOPIC_ID: this.data.topicId,
          TOPIC_TYPE: 'Assignment'
        }
        return this.elearningService.getDetailTopicCourseQuiz(body).pipe(
          switchMap(res => {
            this.data.data[0] = res.result[0];

            const body = {
              TOPIC_ID: this.data.topicId,
              TOPIC_TYPE: this.data.type,
              COURSE_ID: this.data.courseId,
              LESSON_ID: this.data.lessonId
            }
            // // console.log(body);
            this.isLoading = false;

            return this.elearningService.updateStatusLessonTopic(body);
          })
        )
      })
    ).subscribe()
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }
}
